<!--This component accepts the property if the customer has an Extra Spin, if he has he will be redirected to ExtraSpin component,
if he doesn't he will be redirected to Share component-->
<template>
  <div v-if="this.getExtraChance">
    <extra-spin></extra-spin>
  </div>
  <div v-else>
    <share></share>
  </div>

</template>

<script>
import ExtraSpin from "./ExtraSpin";
import Share from "./Share";
import {mapGetters} from "vuex";
import gameFlow from "../common/mixin/gameFlow";

export default {
  name: 'SocialShare',
  mixins: [
    gameFlow
  ],
  mounted() {
    this.setInGameFlow("true", this.$route.path.substring(1))
  },
  computed: {
    ...mapGetters([
      'getExtraChance',
      'getHasBeenAwarded'
    ]),
  },
  components: {
    'extra-spin': ExtraSpin,
    'share': Share
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SocialShare.vue